/**
 * Базовый URL API для axios.
 *
 * REACT_APP_BACKEND_URL — origin/prefix до сегмента `/api`:
 *   (пусто)                         →  /api/...        (production за nginx)
 *   http://127.0.0.1:8000           →  :8000/api/...    (dev, прямой backend)
 *
 * Nginx: location /api/ { proxy_pass http://127.0.0.1:8000/api/; }
 */
export function getBackendOrigin(backendUrl = process.env.REACT_APP_BACKEND_URL) {
  return String(backendUrl || "").trim().replace(/\/+$/, "");
}

export function getApiBaseUrl(backendUrl = process.env.REACT_APP_BACKEND_URL) {
  const base = getBackendOrigin(backendUrl);
  return base ? `${base}/api` : "/api";
}

export function getCrmApiBaseUrl(backendUrl = process.env.REACT_APP_BACKEND_URL) {
  return `${getApiBaseUrl(backendUrl)}/crm`;
}
